  import { RootState } from '../store';

const selectZipCode = (state: RootState) => state.zipCode.selectedZipCode;

export const ZipCodeSelector = {
  selectZipCode,
};
